import { render, staticRenderFns } from "./OrdinanceEditor.vue?vue&type=template&id=0e01e24e&"
import script from "./OrdinanceEditor.vue?vue&type=script&lang=js&"
export * from "./OrdinanceEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports